<section class="container">
  <h1>Gallery</h1>

  <div class="gallery">
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringMenuMar18.webp">
        <img src="/assets/images/gallery/desktop/CateringMenuMar18.jpg" alt="Asparagus with shrimp and rice."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/LentilZucchiniCakes.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/LentilZucchiniCakes.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/LentilZucchiniCakes.webp">
        <img src="/assets/images/gallery/desktop/LentilZucchiniCakes.jpg" alt="Chef drizzling dressing on entree."/>
      </picture>
    </div>
    <blockquote class="item quote">
      <p>All our guests raved about the food, from the appetizers to dinner to the late-night snack.</p>
      <span>Samantha</span>
    </blockquote>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/BaklavaCheesecake.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/BaklavaCheesecake.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/BaklavaCheesecake.webp">
        <img src="/assets/images/gallery/desktop/BaklavaCheesecake.jpg" alt="Golden cake with crumble topping and a side of whipped cream."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/ShrimpWithPeapods.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/ShrimpWithPeapods.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/ShrimpWithPeapods.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/ShrimpWithPeapods.jpg" alt="Ann Arbor chef sprinkles fresh greens on a rice and vegetable dish."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/Tiramisu.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/Tiramisu.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/Tiramisu.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/Tiramisu.jpg" alt="Tiramisu with whipped cream and basil topping."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar180-61.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar180-61.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringMenuMar180-61.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/CateringMenuMar180-61.jpg" alt="Shaved filet mignon on cucumber slice hors d'oeuvres."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-141.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-141.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringMenuMar18-141.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/CateringMenuMar18-141.jpg" alt="Ham panini in paper sleeve with container of pasta salad."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/VeganChocolateCake_010.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/VeganChocolateCake_010.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/VeganChocolateCake_010.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/VeganChocolateCake_010.jpg" alt="University of Michigan chef sprinkles chocolate shavings on vegan chocolate cake."/>
      </picture>
    </div>
    <blockquote class="item quote">
      <p>Our event went extremely well and the guests raved about the breakfast buffet. The servers were courteous and offered useful suggestions for setup. Five-star quality!</p>
      <span>Charles</span>
    </blockquote>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/HealthierSidePlatter-006.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/HealthierSidePlatter-006.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/HealthierSidePlatter-006.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/HealthierSidePlatter-006.jpg" alt="Bagel topped with fresh jam and cantelope and berries on the side. Plate of fruit and more bagels in the background."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-105.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-105.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringMenuMar18-105.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/CateringMenuMar18-105.jpg" alt="Three compostible to-go containers with three salads: fresh salad, couscous salad and pasta salad."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/Bruschetta-004.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/Bruschetta-004.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/Bruschetta-004.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/Bruschetta-004.jpg" alt="Bruschetta with cream cheese and blueberries."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-144.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-144.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringMenuMar18-144.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/CateringMenuMar18-144.jpg" alt="Fresh fruit with whipped cream."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringTstTstngesn-056.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringTstTstngesn-056.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringTstTstngesn-056.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/CateringTstTstngesn-056.jpg" alt="Michigan Catering chef smiling, holding a platter of hors d'oeuvres."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-054.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/CateringMenuMar18-054.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/CateringMenuMar18-054.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/CateringMenuMar18-054.jpg" alt="Wheat cracker with dab of green sauce, small piece of meat and shaved cheese."/>
      </picture>
    </div>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/VeganChocolateCake-013.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/VeganChocolateCake-013.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/VeganChocolateCake-013.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/VeganChocolateCake-013.jpg" alt="Chef tucking a fresh sprig of basil between a piece of chocolate cake and whipped cream."/>
      </picture>
    </div>
    <blockquote class="item quote">
      <p>Y’all are amazing. Thank you so much for helping us provide a great event for our students. Food was excellent and we love the healthy options.</p>
      <span>Andrea</span>
    </blockquote>
    <div class="item">
      <picture>
        <source srcset="/assets/images/gallery/mobile/ShrimpWithPeapods-001.webp" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/mobile/ShrimpWithPeapods-001.jpg" media="(max-width: 450px)">
        <source srcset="/assets/images/gallery/desktop/ShrimpWithPeapods-001.webp">
        <img loading="lazy" src="/assets/images/gallery/desktop/ShrimpWithPeapods-001.jpg" alt="Chef holding small saute pan over over gas burner."/>
      </picture>
    </div>
  </div>
</section>
